import { DocumentDto } from '../../../beneficiary-details/documents/document.dto';

export class RsjInstructionOtherDocumentDto {
  public document: DocumentDto;
  public comment: string;
}
